import { render, staticRenderFns } from "./About.vue?vue&type=template&id=52d8f13e&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&id=52d8f13e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d8f13e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/var/www/app/components/FormInput.vue').default,FormTextarea: require('/var/www/app/components/FormTextarea.vue').default,Btn: require('/var/www/app/components/Btn.vue').default,Page: require('/var/www/app/components/Page.vue').default})
